export default __webpack_public_path__ + "static/media/chart_img.414022df.png";